/**
 * STATE MANAGER (MEV5)
 * Handles the initialization and zeroing of the 4-compartment physiological state.
 */

import { V5PhysiologicalState, ClinicalFraction } from './types';

export const StateManager = {
    
    /**
     * Generates a pristine physiological state with an optional baseline glycogen debt.
     * @param initialGlycogenDebt The carried-over debt from the previous day's simulation.
     */
    createEmptyState(initialGlycogenDebt: number = 0): V5PhysiologicalState {
        const state: V5PhysiologicalState = {
            minute: 0,
            fractions: {} as any,
            insulin: 0,
            gastricVolume: 0,
            glycogenDebt: initialGlycogenDebt,
            intensity: 0
        };

        const fractionKeys: ClinicalFraction[] = [
            'glucose', 'fructose', 'sucrose', 'lactose', 'complex_carbs', 
            'fiber', 'intact_protein', 'free_amino_acids', 'collagen_peps', 'lipids'
        ];

        fractionKeys.forEach(f => {
            state.fractions[f] = { stomach: 0, gut: 0, blood: 0, interstitium: 0 };
        });

        return state;
    },

    /**
     * Returns the array of all valid clinical fractions.
     */
    getFractionKeys(): ClinicalFraction[] {
        return [
            'glucose', 'fructose', 'sucrose', 'lactose', 'complex_carbs', 
            'fiber', 'intact_protein', 'free_amino_acids', 'collagen_peps', 'lipids'
        ];
    }
};
